<template>
  <div class="bg-blog max-w-main" style="min-height: calc(100vh - 51px);">
    <div class="p-1 relative" style="background: rgba(244, 244, 233, 0.60); height: 45px;" >
        <img class="ml-8 h-8 absolute z-50" @click="toHomePage" src="../../assets/logo_web.png" >
    </div>
    <div class="p-2 mt-3">
        <result-success />
    </div>

    <div @click="toEKYC" class=" p-2 mt-3 text-center">
        <button class="bg-main text-white font-bold rounded-md m-auto" style="box-shadow: 4px 3px 5px rgba(100, 21, 95, 0.34); height: 61px; ">Mời bạn cung cấp thêm thông tin để phê duyệt nhanh hơn </button>
    </div>

    <div @click="toHomePage" class="mt-3 color-main2 font-bold text-center">
        Trở về trang chủ
    </div>
  </div>
</template>

<script>
import { getToken, getMoney, getPartner, getLogo } from '@/utils/auth'
import TimaRegister from '../components/tima_register.vue'
import ResultSuccess from '../components/result_success.vue'
import subRoute from '@/router/subRoute'
import router from "@/router";

export default {
    components: {
        TimaRegister,
        ResultSuccess
    },
    data() {
        return {
            partner: getPartner(),
            money: getMoney(),
            logo: getLogo()
        }
    },
    methods: {
        toEKYC(){
            this.$router.push('/info-ekyc.html')
        },
        toHomePage (){
            let r = subRoute
            this.$router.push(r)
        },
        showModal(){
            this.$bvModal.show('modal-pending2')	
        },
        // getPartner(){
        //     //this.$bvModal.show('modal-pending2')
        //     let obj = {
        //         token: getToken()
        //     }
        //     getPartner(obj).then(res => {
        //         if(res.status == 200 || res.status == 0){
        //             this.partner = res.partner
        //             //this.$bvModal.hide('modal-pending2')	
        //             //this.$bvModal.hide('modal-otp')
        //             //setToken(res.token)
        //             //this.$bvModal.show('modal-pending')	
        //             //this.getPartner()
        //         } 
        //     })
        // },
    },
    created() {
        if(!getToken()){
            this.$router.push('/')
        }
       
        // var self  = this
        // setTimeout(() => {
        //         self.getPartner()
        //     },2500);
    },
    mounted() {
        //this.showModal()
    },
    // head: {
    //     script: [
    //         { type: 'text/javascript', src: window.location.origin + router.options.base + '/script/success_page.js'},
    //         { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=AW-10851243888' ,  async: true,},
    //     ],
    //     noscript: [
    //         {
    //             inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1361189891010235&ev=PageView&noscript=1"/>'
    //         }
    //     ]
    // }
}
</script>

<style>

</style>